import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { cssProperties } from "../utils/commonCssProperties";
import { Box } from "@mui/material";

export default function NoOfAttemptsTable({
  tableData,
  columnData,
  totalData,
}) {
  const [rows, setRows] = React.useState(tableData);

  React.useEffect(() => {
    setRows(tableData);
  }, [tableData]);

  return (
    <div>
      <TableContainer
        component={Paper}
        sx={{
          background: "none",
          border: `1px solid ${cssProperties.bordercolor.primary2blue}`,
          boxShadow: "none",
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {columnData?.map((obj, i) => (
                <TableCell
                  sx={{
                    color: cssProperties.bordercolor.primary2blue,
                    textAlign: "center",
                    borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                  }}
                  key={i}
                >
                  {obj.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columnData.map((param, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    sx={{
                      textAlign: "center",
                      borderRight: `1px solid ${cssProperties.bordercolor.primary2blue}`,
                    }}
                  >
                    {row[param.dataIndex]}
                  </TableCell>
                ))}
              </TableRow>
            ))}

            {/* TOTAL ROW */}
            <TableRow>
              {columnData.map((param, cellIndex) => (
                <TableCell
                  key={cellIndex}
                  sx={{ textAlign: "center", fontWeight: "bold" }}
                >
                  {cellIndex === 0 ? "Total" : totalData[param.dataIndex]}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
